<template>
	<div class="sa-list-component">
		<div class="sa-list-component-body">
			<div class="b-table-sticky-header">
				<b-table sticky-header ref="table" :busy="isBusy" stacked="lg" striped hover :items="items"
					:fields="columnVisibile" sort-icon-left head-variant="light" class="sa-b-table"
					:selectable="selectable" select-mode="single" @row-selected="onRowSelectedArticoliItems">
					<template #cell(index)="row">
						{{ (currentPage - 1) * perPage + row.index + 1 }}
					</template>
					<template #cell(lottoMatricola)="row">
						<div class="d-flex flex-column gap-1 align-items-start">

							<div class="sa-ft-badge sa-ft-badge-blue fw-bold mb-1 text-uppercase text-break">
								<font-awesome-icon icon="barcode" class="me-1" />
								{{ row.item.lottoMatricola || 'N/D' }}
							</div>

							<div class="text-muted fst-italic lh-sm small-details ps-1">
								<span v-if="row.item.codiceProdotto" class="d-block mb-1">
									<small class="text-uppercase  text-primary">Cod.Prod:</small> <b> {{
										row.item.codiceProdotto }}</b>
								</span>

								<div class="d-flex flex-wrap gap-2" style="font-size: 0.85rem;">
									<span v-if="row.item.dataProduzione" class="text-primary" title="Data Produzione">
										📅 Prod: {{ formatDate(row.item.dataProduzione) }}
									</span>
									<span v-if="row.item.dataScadenza" title="Data Scadenza"
										:class="{ 'text-danger fw-bold': isScaduto(row.item.dataScadenza) }">
										⌛ Scad: {{ formatDate(row.item.dataScadenza) }}

										<font-awesome-icon v-if="isScaduto(row.item.dataScadenza)"
											icon="exclamation-circle" class="ms-1 text-danger" />
									</span>
								</div>
							</div>
						</div>
					</template>
					<template #cell(nomeArticolo)="row">
						<span style="font-weight: bold">{{ row.item.nomeArticolo }} <span class="text-primary">({{
							row.item.codiceArticolo
						}})</span></span>
						<span style="display: block; font-size: 0.95rem; font-style: italic">{{
							row.item.descrizioneArticolo }}</span>
					</template>
					<template #cell(categoria)="row">
						<div style="display: block; margin-bottom: 4px;" class="sa-ft-badge sa-ft-badge-yellow-sun">{{
							row.item.categoria
						}}</div>
						<div style="display: block;" class="sa-ft-badge sa-ft-badge-water-green">{{
							row.item.marca
						}}</div>
					</template>
					<template #cell(giacenze)="{ item }">
						<div class="inventory-status d-flex flex-column gap-1">
							<div :class="getGiacenzaClass(item.giacenze, item.sottoscortaArticolo)"
								class="fw-bold d-flex align-items-center">
								<span>📦 {{ getGiacenzaTotale(item) }}</span>
								<font-awesome-icon v-if="item.giacenze <= item.sottoscortaArticolo"
									icon="exclamation-triangle" class="m-2 text-warning" />
							</div>
							<div class="text-muted fst-italic small-details">
								<div>
									🏗️ <b>{{ getGiacenzaFormato(item) }}</b> {{ item.descrizioneMultiplo }}
								</div>
								<div>
									🧱 <b>{{ getGiacenzaBase(item) }}</b> {{ item.descrizioneMultiploBase ?
										item.descrizioneMultiploBase : item.descrizioneMultiplo }}
								</div>
							</div>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<b-container class="bv-example-row">
							<b-button size="sm" v-b-tooltip.hover title="Visualizza Articolo"
								variant="outline-secondary" class="mr-1 no-text"
								@click="onClickViewArticoloMagazzino(row.item)">
								<font-awesome-icon icon="eye" />
							</b-button>
							<b-button size="sm" v-b-tooltip.hover class="mr-1 no-text" title="Modifica Articolo"
								variant="outline-success" @click="onClickModificaArticoloMagazzino(row.item)">
								<font-awesome-icon icon="edit" />
							</b-button>

							<b-button size="sm" v-b-tooltip.hover class="mr-1 no-text" title="Rimuovi Articolo"
								variant="outline-danger" @click="onClickRimuoviArticoloMagazzino(row.item)">
								<font-awesome-icon icon="trash" />
							</b-button>
						</b-container>
					</template>
				</b-table>
			</div>
		</div>
		<div class="sa-list-component-invisible">
			<magazzino-articoli-anagrafica-edit-component v-if="showAnagraficaComponent"
				ref="cmpMagazzinoArticoliAnagraficaModalEdit" @articoloMagazzinoDelete="onArticoloDeleted" />
		</div>
		<div class="sa-list-component-footer" v-if="pagination">
			<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col lg="3">
					<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
				</b-col>
				<b-col lg="9">
					<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
						size="sm"></b-pagination>
				</b-col>
			</b-row>
		</div>
	</div>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import MagazzinoArticoliAnagraficaEditComponent from "./MagazzinoArticoliAnagraficaEditComponent.vue";
export default {
	name: "MagazzinoArticoliListComponent",
	mixins: [UtilityMixin],
	inject: ["openShowModalLoading", "closeShowModalLoading"],
	components: { MagazzinoArticoliAnagraficaEditComponent },
	props: {
		selectable: { type: Boolean, default: false },
		component: { type: Boolean, default: false },
		perPageCustom: { type: Number, default: 100 },
		tableHideColumn: {
			type: Array,
			default: () => {
				return ["codiceAzienda", "dataScadenza"];
			},
		},
		pagination: { type: Boolean, default: true },
	},
	mounted() {
		if (this.perPageCustom != 100) {
			this.perPage = this.perPageCustom;
		}
	},
	computed: {
		columnVisibile() {
			return this.fields.filter((e) => !this.tableHideColumn.includes(e.key));
		},
	},
	watch: {
		items: function (params) {
			console.log(params.length);
			if (params.length == 1) {
				this.$nextTick(() => {
					if (this.$refs.table) {
						this.$refs.table.selectRow(0);
					}
				});
			}
		},
		currentPage: function () {
			if (this.pagination) {
				this.loadDataArticoli();
			}
		},
	},
	data() {
		return {
			isBusy: false,
			rows: 0,
			perPage: 100,
			currentPage: 1,
			showAnagraficaComponent: false,
			pathResource: "/magazzinoarticoli/giacenza/codici",
			linkEdit: "/magazzino/articoli",
			linkView: "/magazzino/articoli/view",
			filtroCustom: {},
			btnAggiungi: false,
			items: [],
			filtroArticoliMagazzino: { nomeArticolo: null, codiceTipoArticolo: null, stato: null },
			fields: [
				{
					label: "",
					key: "index",
					sortable: true,
					thStyle: "width: 2rem",
				},
				{
					label: "Nome",
					key: "nomeArticolo",
					sortable: true,
				},
				{
					label: "Codice Matricola/Lotto",
					key: "lottoMatricola",
					sortable: true,
				},
				{
					label: "Codice Azienda",
					key: "codiceAzienda",
					sortable: true,
				},

				{
					label: "Categoria Marca",
					key: "categoria",
					sortable: true,
				},

				{
					label: "Magazzino",
					key: "magazzinoDescrizione",
					sortable: true,
					formatter: (v) => {
						return v == null ? 'NO-STOCK' : v.toUpperCase();
					}
				},
				{
					label: "Giacenze",
					key: "giacenze",
					thStyle: "width: 8rem; white-space: nowrap;",
					tdClass: "text-nowrap",
					sortable: true,
				},
				{ class: "sa-table-column-action-double", key: "actions", label: "" },
			],
		};
	},
	methods: {
		onRowSelectedArticoliItems(item) {
			this.$emit("onRowSelectedArticoliItems", item);
		},
		getGiacenzaTotale(item) {
			return item.giacenze == 0 ? item.giacenze : item.giacenze.toFixed(1);
		},
		getGiacenzaFormato(item) {
			return item.giacenzaFormato;
		},
		getGiacenzaBase(item) {
			return item.giacenzaBase;
		},
		loadDataArticoli(filter) {
			let me = this;
			me.$emit("beforeLoadData");
			let filtro = {};
			this.openShowModalLoading();
			if (!me.component) {
				if (sessionStorage["filtroMagazzino"]) {
					me.filtroArticoliMagazzino = JSON.parse(sessionStorage["filtroMagazzino"]);
				}
				filtro = { ...me.filtroArticoliMagazzino };
				me.$emit("updateFilter", me.filtroArticoliMagazzino);
				filtro = { ...filtro, forPage: me.perPage, page: me.currentPage };
			} else {
				filtro = filter;
			}
			filtro = { ...filtro };
			console.log(filtro);

			UtilityMixin.methods.loadDataResources(me.pathResource, filtro, me.loadDataArticoliSuccess, me.loadDataArticoliError);
		},
		loadDataArticoliSuccess(response) {
			let me = this;
			me.items = response.data.data.list;
			me.rows = response.data.data.recordsNumber;
			this.$emit("updateRowNumberGiacenza", me.rows);
			me.$emit("afterLoadData");
			this.closeShowModalLoading();
		},
		loadDataArticoliError(response) {
			let me = this;
			me.$emit("afterLoadData");
			response;
			this.closeShowModalLoading();
		},
		isScaduto(dataScadenza) {
			if (!dataScadenza) return false;

			const dataScadenzaOggetto = new Date(dataScadenza);
			const oggi = new Date();


			oggi.setHours(0, 0, 0, 0);
			dataScadenzaOggetto.setHours(0, 0, 0, 0);

			return dataScadenzaOggetto < oggi;
		},
		onClickRimuoviArticoloMagazzino(item) {
			let me = this;
			me.showAnagraficaComponent = true;
			me.$nextTick(() => {
				me.$refs.cmpMagazzinoArticoliAnagraficaModalEdit.onDeleteArticoloMagazzino(item);
			});
		},
		onArticoloDeleted() {
			let me = this;
			me.showAnagraficaComponent = false;
			me.loadDataArticoli();
		},
		onClickViewArticoloMagazzino(item) {
			let me = this;
			me.$router.push("/magazzino/articoli/view/" + item.id);
		},
		onClickModificaArticoloMagazzino(item) {
			let me = this;
			me.$router.push("/magazzino/articoli/edit/" + item.id);
		},
		getGiacenzaClass(giacenza, sottoscorta) {
			return giacenza <= sottoscorta ? "text-danger font-weight-bold" : "text-success font-weight-bold";
		},
	},
};
</script>
<style scoped>
.product-card {
	background: white;
	border-radius: 15px;
	overflow: hidden;
	border: 1px solid #e2e8f0;
	transition: all 0.3s;
}

.badge-soft {
	padding: 4px 10px;
	border-radius: 6px;
	font-size: 0.7rem;
	font-weight: 700;
}

.bg-blue-soft {
	background: #ebf8ff;
	color: #3182ce;
}

.product-img {
	height: 80px;
	background: #edf2f7;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 3.5rem;
}

.product-content {
	padding: 15px;
}

.mb-1 {
	margin-bottom: .25rem !important;
}

.text-truncate {
	overflow: hidden !important;
	text-overflow: ellipsis !important;
	white-space: nowrap !important;
}

.product-price {
	font-size: 1.25rem;
	font-weight: 800;
	color: #2d3748;
}

.sa-ft-badge {
	padding: 3px 10px;
	border-radius: 12px;
	font-size: 0.80rem;
	font-weight: 500;
	display: inline-block;
	border: 1px solid #dee2e6;
	max-width: fit-content;
	text-align: center;
}

.sa-ft-label {
	font-size: 0.78rem;
	font-weight: 500;
	color: #888;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	margin-bottom: 2px;
}

.sa-ft-badge-blue {
	background-color: #e8f0fe;
	color: #1a73e8;
	border-left: 3px solid #1a73e8 !important;
	border: 1px solid #1a73e8;
}

.sa-ft-badge-water-green {
	background-color: #e8f0fe;
	color: #0e7463;
	border-left: 3px solid #0e7463 !important;
	border: 1px solid #0e7463;
}

.sa-ft-badge-yellow-sun {
	background-color: #e8f0fe;
	color: #898b09;
	border-left: 3px solid #898b09 !important;
	border: 1px solid #898b09;
}

.sa-ft-badge-purple {
	background-color: #e8f0fe;
	color: #5b69bc;
	border-left: 3px solid #5b69bc !important;
	border: 1px solid #5b69bc;
}
</style>
